"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLayoutEffectSSRSafe = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// useLayoutEffect does't play well with NextJS SSR: https://medium.com/@alexandereardon/uselayouteffect-and-ssr-192986cdcf7a
var useLayoutEffectSSRSafe = typeof window !== 'undefined' ? _react["default"].useLayoutEffect : _react["default"].useEffect;
exports.useLayoutEffectSSRSafe = useLayoutEffectSSRSafe;